import { AssetType, OnboardingFulfilledBy, Product } from '@nemuru-eng/js-api-client';

import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';

import { getDynamicPagePathByOnboardingFulfilledBy } from './getDynamicPagePathByOnboardingFulfilledBy';

export const getDynamicPagePathByProductType = (
  productType: Product,
  assetType: AssetType,
  onboardingFulfilledBy: OnboardingFulfilledBy,
) => {
  if (assetType === AssetType.ORDER) {
    return getDynamicPagePathByOnboardingFulfilledBy(onboardingFulfilledBy);
  }
  switch (productType) {
    case Product.AUTO:
      return DYNAMIC_PAGE_PATHS.AUTO_LOAN;
    case Product.CREDIT_LINE:
      return DYNAMIC_PAGE_PATHS.CREDIT_LINE;
    default:
      return DYNAMIC_PAGE_PATHS.CONSUMER_LOAN;
  }
};
